import { Container, Row, Col } from 'react-bootstrap';

/**
 * Componente Loading para la interfaz de la tienda
 * @component
 */
const PurchasesLoading = (): JSX.Element => {

    return (
        <Container className='py-3 px-1'>
            <Row className='g-0'>
                <Col xs={12} className='justify-content-end px-3'>
                    <Row className='mx-3 mb-2'>
                        <Col xs={12} className='shadow rounded svg-secondary-1 '>
                            <Row>
                                <Col md={12} className='gradient-loading py-4 rounded'></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mx-3'>
                        <Col xs={12} className='shadow rounded svg-secondary-1 '>
                            <Row>
                                <Col md={12} className='gradient-loading py-4 rounded'></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='mx-2 mt-3'>
                        <Col className={'p-0 '}>
                            {[...Array(2)].map((_, index) => (
                                <Row key={index + 1} className=' mx-2'>
                                    <Col className='gradient-loading mh-200-px mx-auto mb-3 rounded'></Col>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default PurchasesLoading;
